import { PlusIcon } from "@heroicons/react/outline";

function WorkflowOverviewBlockPlaceholder(props: { text: string, onClick: () => void }) {
  return (
    <button className="relative flex flex-shrink-0 items-center justify-center px-8 py-8 border-dashed border-2 border-gray-300 cursor-pointer rounded w-[600px] h-[114px] text-gray-300 hover:text-blue hover:border-blue transition-all" onClick={props.onClick}>
      <div className="flex items-center gap-1 text-xl whitespace-nowrap font-gilroy font-semibold">
        <PlusIcon className="w-6 h-6" /> {props.text}
      </div>
    </button>
  );
}

export default WorkflowOverviewBlockPlaceholder;
